import React from 'react';
import { StyledFlexBox } from './FlexBox.style';

const FlexBox = (props) => {
  return <StyledFlexBox {...props}>{props.children}</StyledFlexBox>;
};

export default FlexBox;
